<template lang="html">
  <div class="text-field form-group mb-0" :class="{ 'has-error': isError }">
    <v-text-field
      v-if="!isReadOnly"
      ref="textfield"
      type="text"
      dense
      outlined
      :error="isError"
      :maxlength="maxlength"
      :id="id"
      :disabled="disabled"
      :name="label"
      :placeholder="placeholder"
      :data-testid="testId"
      :label="label"
      :value="value"
      :data-tourid="tourId"
      @input="$emit('input', $event)"
      @blur="$emit('focusOut')"
    ></v-text-field>

    <div v-else>
      <FieldLabel :text="label" :disabled="disabled" />

      <p
        class="text-field__value-label body-2 grey--text text--darken-4"
        :data-testid="`${testId}-value-label`"
      >
        {{ value }}
      </p>
    </div>
    <p
      v-if="isStringError"
      class="error-message"
      :data-testid="`${testId}-error-message`"
    >
      {{ error }}
    </p>
  </div>
</template>

<script>
import FieldLabel from '@/components/Core/FieldLabel'
import { isString } from 'lodash'

export default {
  name: 'TextField',

  components: {
    FieldLabel,
  },
  props: {
    tourId: {
      type: String,
      required: false,
      default: 'textField',
    },
    id: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    testId: {
      type: String,
      default: 'text-field',
    },
    value: {
      type: [String, Number],
      required: false,
    },
    error: {
      type: [String, Boolean],
      required: false,
    },
    isReadOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxlength: {
      type: Number,
      required: false,
      default: 90,
    },
  },

  computed: {
    isError() {
      return this.error?.length > 0 || this.error === true
    },
    isStringError() {
      return isString(this.error)
    },
  },
}
</script>
